var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('span',[_c('router-link',{staticStyle:{"text-decoration":"underline"},attrs:{"to":{
        path: _vm.link,
        query: _vm.query
      }}},[_vm._v(_vm._s(_vm.text))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }